import { render } from "./WeekDayPicker.vue?vue&type=template&id=282afad8"
import script from "./WeekDayPicker.vue?vue&type=script&lang=js"
export * from "./WeekDayPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__